<template>
  <div
    class="mask-content flex"
    :style="{ height: height + 'px', 'margin-left': -left + 'px' }"
  >
    <div class="icon-wrap flex">
      <div class="icon-item flex" v-for="(icon, index) in iconArr" :key="index">
        <img :src="icon.img" />
        <p>{{ icon.name }}</p>
      </div>
    </div>
    <p class="explain">成为迷你世界创作者，查看更多作品相关数据</p>
    <div class="btn-register" @click="developerClick">
      <a :href="registerUrl" target="_blank">成为创作者</a>
    </div>
  </div>
</template>

<script>
// import { RegistryReferer } from '@/types';
// import { createRegisterUrl } from '@/utils';
// import {reportData} from '@/main.js'
import { mapState } from 'vuex';
export default {
  props: {
    height: {
      type: Number,
      default: 0,
    },
    left: {
      type: Number,
      default: 0,
    },
    homeType: {
      type: Boolean,
      default: false,
    },
    mapType: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      registerUrl:
        'https://dev-wiki.mini1.cn/cyclopdeia?wikiMenuId=1634&wikiId=805', // createRegisterUrl(RegistryReferer.MapData),
      iconArr: [
        {
          name: '数据分析',
          img: require('@/assets/images/icon_mask_analysis.png'),
        },
        {
          name: '监测观察',
          img: require('@/assets/images/icon_mask_monitor.png'),
        },
        {
          name: '收益查询',
          img: require('@/assets/images/icon_mask_income.png'),
        },
      ],
      userTxt: '开发者',
      // developerInfo
    };
  },
  computed: {
    ...mapState(['developerInfo', 'userInfo']),
  },
  mounted() {
    this.becomeDShow();
    let version = '';
    //判断是否是427版本
    if (this.userInfo.ver) {
      let ver = this.userInfo.ver.split('.');
      version =
        (parseInt(ver[0]) << 16) + (parseInt(ver[1]) << 8) + parseInt(ver[2]);
      if (version >= 68608) {
        this.userTxt = '开发者';
      } else {
        this.userTxt = '开发者';
      }
    }
  },
  methods: {
    developerClick() {
      //首页-认证开发者点击埋点
      if (this.homeType) {
        this.$log('approve_developer_click', 85406, { v7: 1 });
      }
      //地图-认证开发者按钮点击
      if (this.mapType) {
        this.$log('become_developer_click', 85409, { v7: 1 });
      }
    },
    //地图-认证开发者按钮展示
    becomeDShow() {
      this.$log('become_developer_show', 85408, { v7: 1 });
    },
  },
};
</script>

<style lang="scss" scoped>
.mask-content {
  flex-direction: column;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100% !important;
  background: rgba(255, 255, 255, 0.92);
  border-radius: 8px;
}
.icon-wrap {
  width: 70%;
}
.icon-item {
  flex-direction: column;
  justify-content: space-around;
  p {
    color: #5c5c5c;
    font-size: 16px;
  }
  img:hover {
    filter: brightness(95%);
  }
}
.explain {
  font-size: 20px;
  color: #6e6969;
}
.btn-register {
  width: 200px;
  height: 50px;
  font-size: 20px;
  background: #a75eff;
  border-radius: 8px;
  cursor: pointer;
  text-align: center;
  line-height: 50px;
  &:hover {
    filter: brightness(95%);
  }
  > a {
    display: block;
  }
}

.flex {
  display: flex;
  align-items: center;
  justify-content: space-around;
  a {
    color: #fff;
    text-decoration: none;
  }
}
</style>
